<template>
  <div id="news_sub">
    <div class="con_all">
      <div class="con_box2">
        <div class="tea_r_l">
          <div class="tx18">{{news.title}}</div>
        </div>
        <div class="tea_r_r">
          <div class="tx18">{{news.createdAt && news.createdAt.split(' ')[0]}}</div>
        </div>
        <div class="fix"></div>
        <div class="team_bbox" v-html="(news.context)"></div>
        <div class="tea_r_l"></div>
        <div class="tea_r_r">
          <button type="submit" class="gue_btn" @click="back">{{backname}}</button>
        </div>
        <div class="fix"></div>
        <p>{{attachPicture}}</p>
        <div v-for="(picture,index) in news.pictures" :key="'i'+index">
          <div style="float:left;margin:25px;"><img width="212" style="cursor:pointer;" :src="picture.file_url" @click="showPicture(picture.file_url)"></div>
        </div>
        <div class="fix"></div>
        <p>{{attachFile}}</p>
        <div v-for="(file,index) in news.files" :key="'f'+index">
          <a :href="file.file_url" download>{{file.file_name}}</a>
        </div>
        <div class="fix"></div>
      </div>
    </div>
    <Modal v-model="pictureModal" class-name="pictureModal">
      <img :src="imgUrl">
      <div slot="footer"></div>
    </Modal>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message } from '@/assets/project_setting/config';
import { GetErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';

export default {
  name: 'news_sub',
  props: ['newsitem'],
  data() {
    return {
      newsId: this.$route.params.newsid,
      news: '',
      locale: sessionStorage.getItem('locale'),
      attachPicture: { CH: '附加圖檔', EN: 'Attach Picture' },
      attachFile: { CH: '附加檔案', EN: 'Attach File' },
      backname: { CH: '回上一頁', EN: 'back' },
      imgUrl: '',
      pictureModal: false,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.showPage();
      this.initNews();
    },
    initNews() {
      if (this.newsitem) {
        this.news = this.newsitem;
      }
      if (!this.newsitem) {
        this.getNewsData();
      }
    },
    getNewsData() {
      axios.get(API.notice + `?id=${this.newsId}`)
        .then(response => {
          this.news = response.data;
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    back() {
      // this.$router.go(-1);
      window.history.go(-1)
    },
    showPage() {
      this.attachPicture = this.attachPicture[this.locale];
      this.attachFile = this.attachFile[this.locale];
      this.backname = this.backname[this.locale];
    },
    showPicture(url) {
      this.pictureModal = true;
      this.imgUrl = url;
    },
  },
}

</script>
<style lang="scss">
#news_sub {
  .cla_box {
    width: 100%;
    background: red;
    padding: 15px 20px;
    margin-top: 40px;
    border-radius: 3px;
    background: -webkit-linear-gradient(0deg, #E7E7E7, #fff);
    background: linear-gradient(0deg, #E7E7E7, #fff);
    border: 1px solid #E2E2E2;
    border-bottom: 1px solid #A2A2A2;
  }
  
}
.pictureModal {
  .ivu-modal {
    width: 1000px !important;
    img {
      max-width: 900px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// NewsSub.vue?26649b88